// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".side-bar-border[data-v-74dccd2f]{border:1px solid #ececec;border-radius:30px;width:-moz-fit-content;width:fit-content;padding:5px 10px!important;cursor:pointer;position:fixed;right:10px;top:120px;background:#fff;box-shadow:0 10px 15px -3px rgba(0,0,0,.1);z-index:3}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
